
import $ from 'jquery';
import { RanchVariableData, RanchVariablesCategorized, SatellitalValues } from '../../../typescript/satellital/evolution_chart';
import { Component, Mixins, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import {  parseFloatNumber, timestampToTime } from '../../../core/utils/date-handlers';
import { getValueWithCustomDecimals, milisecondsToTimestamp } from '../../../typescript/values/valueFormatter';
import { Chart } from 'highcharts-vue';
import InfoIcon from '../../../core/components/Generics/InfoIcon.vue'
import Highcharts, { chart } from 'highcharts';
import exportingInit from 'highcharts/modules/exporting';
import moment from 'moment';
exportingInit(Highcharts);
import loading from 'vue-loading-overlay';
import { nullOrEmptyFormatter } from '../../../typescript/values/valueFormatter';
import LoadingIndicator from '../../../core/components/Generics/LoadingIndicator.vue'
import Axios, { CancelTokenSource } from 'axios';
import { UnitLabels } from '../../../../features/typescript/values/unitLabels';
import { ColorsList, EventBus, TypeEventBus } from '../../../../features/core/utils';
import { ClaimsApi } from '../../../core/api/ClaimsApi';
import { showErrorSnackbar } from '../../../../features/helpers/alerts-popups';
import { SatellitalImage } from '../../../../features/typescript/satellital/satellital_images';
import { SatellitalLayersInfo, ZonificationInfo } from '../../../../features/typescript/satellital/layers';
@Component({
    components: {
        highcharts: Chart,
        loading,
        InfoIcon,
        LoadingIndicator
    }
})

export default class SatellitalEvolutionChart extends Vue {
    @Prop({default(){return []}}) satelliteImages: Array<object>;
    @Prop({default: ''}) currentTimestamp: object;
    @Prop({default: -1}) sinisterId: number;
    @Prop({default: null}) eventDate: string;
    bandSelected: string | null = 'NDVI';
    selectedImage: SatellitalImage | null = null;
    collapsiblePanel: number | null = 0;
    activesVariables: string[] = [];
    variables: Array<RanchVariableData> | [] = [];
    categorizedVariables: RanchVariablesCategorized | null = null;
    allVariablesInfo: RanchVariablesCategorized | null = null;
    tooltipMsgAdd = 'Añadir variable a gráfica actual';
    tooltipMsgRemove = 'Quitar variable de la gráfica actual';
    gettingVariables: boolean = false;
    isLoadingLayers: boolean = true;
    colorMin: string = ColorsList.purple;
    colorMax: string = ColorsList.orange;
    colorMedian: string = ColorsList.skyblue;
    minTemp: number | null = null; 
    maxTemp: number | null = null; 
    avgTemp: number | null = null; 
    sumRain: number | null = null;
    zonificationTs: number | null = null;
    maxTempDays: number | null = null; 
    unitTemp: string = UnitLabels.temperature;
    unitRain: string = UnitLabels.rain;
    requestTokenInstance: CancelTokenSource = Axios.CancelToken.source();
    isLoaded: boolean = false;
    currentPlotLines: Array<object> = [];
    currentImageIndex: number = 0;
    satellitalLayersInfo: SatellitalLayersInfo = {
            zonified: {
            date: null,
            bar_url: '',
            png_url: null,
            total_area: null,
            zones: [],
            bounds: null
        },
        ndvi: {
            initial_date: null,
            final_date: null,
            bar_url: '',
            png_url: null,
            total_area: null,
            zones: [],
            bounds: null
        }
    }
    chartOptions: object = {
        events: {
            load: function(){
                $(window).trigger('resize')
            },
        },
        tooltip: {
            
            formatter: function() {
                let seriesName = this.series.name;
                let serieCategory = this.series.userOptions.category;
                return `
                    <b>Variable: ${seriesName}</b><br>
                    <b>Fecha:</b> ${moment(this.x).format('DD/MM/YYYY')}<br>
                    <b>Valor:</b> 
                        ${getValueWithCustomDecimals(this.point.y)} 
                        ${serieCategory !== 'satellital' ? UnitLabels[serieCategory] :  ''}
                `
            }
        },
        legend: { enabled: true },
        chart: {
            zoomType: 'x'
        },
        title: {
            text: ''
        },
        yAxis: [
            {
                opposite: false,
                showLastLabel: true,
                alignTicks: false,
                title: {
                    text: ''
                }
            },
            {
                opposite: true,
                alignTicks: false,
                showLastLabel: true,
                title: {
                    text: ''
                }
            }
        ],
        time: {
            useUTC: false
        },
        xAxis: {
            ordinal: false,
            minPadding: 0,
            maxPadding: 0,
            title: {
                text: 'Fecha'
            },
            type: 'datetime',
            labels: {
                format: '{value:%e/%m/%y}'
            },
            plotLines: [],
            events: {
                setExtremes: event => {
                    let minDate = '';
                    let maxDate = '';
                    if (event && !event.min && !event.max) {
                        minDate = '';
                        maxDate = '';
                    }else{
                        minDate = milisecondsToTimestamp(new Date(event.min));
                        maxDate = milisecondsToTimestamp(new Date(event.max));
                    }
                    this.updateStats(minDate, maxDate)
                }
            },
        },
        plotOptions: {
            series: {
                cursor: 'pointer',
                point: {
                    events: {
                        click: (event) => {
                            if(event.point.series.userOptions.category === 'satellital'){
                                this.clickChartPoint(event.point.index);
                            }
                        }
                    }
                }
            }
        },
        series: [],
        exporting: {
            buttons: {
                contextButton: {
                    menuItems: [
                        'downloadPNG',
                        'downloadJPEG',
                        'downloadPDF',
                    ]
                }
            }
        }
    };
    chartReferences: Array<object> = [];
    satelliteReferences: Array<object> = [
        {
            color: ColorsList.green,
            value: 'Imagen Seleccionada'
        },
        { 
            color: ColorsList.navy_blue, 
            value: 'Fecha zonificación' 
        }
    ];
    baseReferences: Array<object> = [
        {
            color: this.colorMedian,
            value: 'Mediana'
        },
        {
            color: this.colorMin,
            value: 'Mínimo'
        },
        {
            color: this.colorMax,
            value: 'Máximo'
        }
    ];
    categoriesLabel: object = {
        humidity: 'Humedad',
        temperature: 'Temperatura',
        rain: 'Lluvia',
        satellital: 'Satelital'
    }

    categoriesInfo: object = {
        humidity: 'Humedad relativa del aire (%)',
        temperature: '',
        rain: '',
        satellital: ''
    }

    minMaxMeanColor: object = {
        min: ColorsList.purple,
        max: ColorsList.orange,
        mean: ColorsList.skyblue,
    }

    categoriesColors: object = {
        humidity: this.minMaxMeanColor,
        temperature: this.minMaxMeanColor,
        rain: this.minMaxMeanColor,
        satellital: this.minMaxMeanColor
    }
    satellitalMinPoint: number = 0;
    satellitalMaxPoint: number = 1;
    datetimeFrom: string = '';
    datetimeTo: string = '';
    loadingStats: boolean = false;
    private statsReqId = 0;

    rgbAndNdviValues: SatellitalValues = {
        NDVI: [],
        RGB: []
    };
    rgbAndNdviSetted: boolean = false;

    get getCategorizedVariables(){
          if (!this.bandSelected || !this.allVariablesInfo) {
            return this.categorizedVariables
        }

        const variablesInfo = this.allVariablesInfo;
        const climateKeys = ['humidity', 'rain', 'temperature'];
        const rest: any = {};
        Object.keys(variablesInfo).forEach(key => {
          if (climateKeys.indexOf(key) !== -1) {
            rest[key] = variablesInfo[key];
          }
        });

        // elegimos la capa activa (incluye "NDVI Diff" → "ndvi diff")
        const selected = variablesInfo[this.bandSelected.toLowerCase()]

        return {
            ...rest,
            satellital: selected
        }
    }

    buildPlotLines(): any[] {
        const pls: any[] = [];

        // Imagen seleccionada
        if (this.variableIsActive('satellital') && this.selectedImage && this.selectedImage.date) {
            const tsSel = moment(this.selectedImage.date).toDate().valueOf();
            if (!isNaN(tsSel)) {
            pls.push({ id: 'selected-image-plotline', color: ColorsList.green, width: 2, value: tsSel, zIndex: 99 });
            }
        }

        // Zonificación
        if (this.variableIsActive('satellital') && this.zonificationTs != null) {
            pls.push({ id: 'zonification-plotline', color: ColorsList.navy_blue, width: 2, value: this.zonificationTs, zIndex: 99 });
        }

        if(this.eventDate !== null){
            let eventDate = moment(this.eventDate).toDate().valueOf();
            pls.push({ id: 'event-date-plotline', color: ColorsList.red, width: 2, value: eventDate, zIndex: 99 });
        }

        return pls;
    }

    applyPlotLines() {
        this.currentPlotLines = this.buildPlotLines();

        if (!this.chartOptions['xAxis']) this.chartOptions['xAxis'] = {};
        this.$set(this.chartOptions['xAxis'], 'plotLines', this.currentPlotLines.map(p => ({ ...p })));

        const chartRef: any = this.$refs.chartSatellite;
        const chart = chartRef && chartRef.chart;
        if (chart && chart.xAxis && chart.xAxis[0]) {
            try { chart.xAxis[0].removePlotLine('selected-image-plotline'); } catch (e) {}
            try { chart.xAxis[0].removePlotLine('zonification-plotline'); } catch (e) {}
            this.currentPlotLines.forEach(pl => chart.xAxis[0].addPlotLine(pl));
            chart.redraw();
        }
    }


        removePlotLineById(lineId: string) {
            const chartRef: any = this.$refs.chartSatellite;
            const chart = chartRef && chartRef.chart;
            if (!chart || !chart.xAxis || !chart.xAxis[0]) return;
            try { chart.xAxis[0].removePlotLine(lineId); chart.redraw(); } catch (e) {}
        }

    updateStats(datetime_from: string, datetime_to: string) {
        this.requestTokenInstance.cancel();
        this.requestTokenInstance = Axios.CancelToken.source();

        const myId = ++this.statsReqId; 
        this.loadingStats = true;

        this.minTemp = 0; this.maxTemp = 0; this.avgTemp = 0; this.sumRain = 0; this.maxTempDays = 0;

        ClaimsApi.getStatsForSatellitalChart(
            this.sinisterId,
            this.requestTokenInstance,
            datetime_from,
            datetime_to,
        ).then((res) => {
            if (this.statsReqId !== myId) return;
            this.minTemp = parseFloatNumber(res.temperature_min);
            this.maxTemp = parseFloatNumber(res.temperature_max);
            this.avgTemp = parseFloatNumber(res.temperature_avg);
            this.sumRain = parseFloatNumber(res.rain_sum, 2);
            this.maxTempDays = parseFloatNumber(res.max_temperature_days, 2);
        }).catch((err) => {
            if (Axios.isCancel && Axios.isCancel(err)) return;
        }).finally(() => {
            if (this.statsReqId === myId) this.loadingStats = false;
        });
    }

    valueFormatter(value){
        return nullOrEmptyFormatter(value)
    }


    updateCarouselIndex(index: number){
        this.currentImageIndex = index;
        this.updateCurrentTimestampImage();
    }

    updateSelectedImage(image: SatellitalImage | null){
        this.selectedImage = image;
    }

    updateSelectedBand(band){
        this.bandSelected = band;
    }

    @Watch('bandSelected', { immediate: true })
    onBandChanged(){
        this.bandChangedEvent();
    }

    bandChangedEvent(){
        //evento que se dispara cuando cambia el tipo de banda
        //si la variable satelital esta activa la quito
        if(this.gettingVariables) return

        if(this.variableIsActive('satellital')){
            this.removeVariableFromChart('satellital');
        }
        this.addVariableToChart('satellital');
    }


    updateChartReferences() {
        const hasMin = this.chartOptions['series'].some(s => /\(Mín\)/.test(s.name));
        const hasMax = this.chartOptions['series'].some(s => /\(Max\)/.test(s.name));

        const refs:any = [];

         if(this.eventDate !== null){
            refs.push({ color: ColorsList.red, value: 'Fecha evento' });
        }

        refs.push({ color: this.colorMedian, value: 'Mediana' });
        
        
        if (hasMin) refs.push({ color: this.colorMin, value: 'Mínimo' });
        if (hasMax) refs.push({ color: this.colorMax, value: 'Máximo' });

        if (this.variableIsActive('satellital')) {
            refs.push({ color: ColorsList.green, value: 'Imagen Seleccionada' });
            if (this.zonificationTs != null) {
            refs.push({ color: ColorsList.navy_blue, value: 'Fecha zonificación' });
            }
        }
       
        this.chartReferences = refs;
        }

    updateCurrentTimestampImage(){
        if (this.variableIsActive('satellital')) this.applyPlotLines();
    }



    async getVariables(){
        this.gettingVariables = true;
        let self = this;

        ClaimsApi.getSatellitialVariablesWithValues(
            this.sinisterId
        )
        .then((res: RanchVariablesCategorized) => {
            // Bandas satelitales (NDVI, RGB, NDVI Diff, …) vienen en el WS de imagenes
            const satValues = self.rgbAndNdviValues || {};
            Object.keys(satValues).forEach(bandKey => {
                res[bandKey] = satValues[bandKey];
            });

            this.updateStats('', '');

            const lower = Object.fromEntries(
                Object.entries(res).map(([k, v]) => [String(k).toLowerCase(), v])
            ) as any;

            const climateKeys = ['humidity', 'rain', 'temperature'];
            const nextInfo: any = {
                humidity: lower.humidity,
                rain: lower.rain,
                temperature: lower.temperature,
            };

            Object.keys(lower).forEach(key => {
                if (climateKeys.indexOf(key) !== -1) return;
                const arr = Array.isArray(lower[key]) ? lower[key] : [];
                arr.forEach((image: any) => {
                    if (image && typeof image === 'object') {
                        image.band = key;
                    }
                });
                nextInfo[key] = arr;
            });

            this.allVariablesInfo = nextInfo;
        })
        .catch(() => {
            showErrorSnackbar('No se pudieron obtener las variables');
        })
        .finally(() => {
            this.updateIsLoadingLayers(false);
            this.gettingVariables = false;
            this.preselectSatellitalVariable();
        });
    }

  

    removeVariableFromChart(category:string) {
        //quito la variable de la lista de activas
        try{
        
            this.activesVariables = this.activesVariables.filter((item) => {
                return item !== category;
            })

            //quito las plotLines del grafico si no hay variables satelitales activas
            if (!this.variableIsActive('satellital')) {
                this.currentPlotLines = [];
                this.applyPlotLines();
                this.updateChartReferences();
            }


            //quito la variable de la lista de series
            let filteredSeries = this.chartOptions['series'].filter((item) => {
                return item['category'] !== category;
            })

            this.$set(this.chartOptions, 'series', filteredSeries);

        }catch(e){
            // console.log("error al quitar una variable", e);
        }
    }

    toggleVariable(category:string) {
        /* 
            si la variable esta activa, la quito
            si la variable no esta activa, la agrego
        */
        if(this.variableIsActive(category)){
            this.removeVariableFromChart(category);
        }else{
            this.addVariableToChart(category);
        }
        this.redrawChart();

        
    }

    redrawChart(){
        //redibujo el grafico
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'))
        }, 500);
    }

    get variableIsActive(){
        return (variable: string) => {
            return this.activesVariables.includes(variable);
        }
    }

    getMinMeanSatellitalPoint(images){
        return images.map((item) => {
                return item['value']['mean'];
            }).sort((a, b) => {
                return a - b;
            })[0];
    }

    getMaxMeanSatellitalPoint(images){
        return images.map((item) => {
                return item['value']['mean'];
            }).sort((a, b) => {
                return b - a;
            })[0];
    }

    getCurrentSatelliteImagesByBand(){
        //devuelve las imagenes satelitales filtradas por tipo de banda
        let images = this.satelliteImages.filter((item) => {
            return item['band'] === this.bandSelected;
        })
        return images;
    }


    setRgbAndNdviValues(values: SatellitalValues){
        this.rgbAndNdviValues = values;
        this.rgbAndNdviSetted = true;
        this.getChartData();
    }

    getCurrentSatellitalCategory(category){
        if(category === 'satellital'){
            return this.bandSelected ? this.bandSelected.toLowerCase() : 'ndvi'
        }
        return category
    }


    addVariableToChart(category:string){
        /* Agrego grafica nueva */

        //me fijo si la variable tiene datos
        let variableData = this.allVariablesInfo && this.allVariablesInfo[this.getCurrentSatellitalCategory(category)] || [];
        
        let variableHasData = variableData.length > 0;
        if(!variableHasData){
            if(this.isLoaded){
              showErrorSnackbar(`No hay datos de ${category}`)
            }
            return;
        }
        
        //si la variable tiene datos
        //agrego la variable a la lista de activas
        if(!this.variableIsActive(category)){
            this.activesVariables.push(category);
        }

        //me quedo con el tipo de grafico que corresponde a la categoria
        let seriesType = this.getChartTypeByCategory(category);

        let points: Array<{
            x: number;
            yMin: number;
            yMax: number;
            yMean: number;
        }> = [];

        //convierto los datos a puntos para el grafico

         //si la variable es categoría satelital, filtro los puntos por tipo de banda
         let self = this;
         if(this.variableIsActive('satellital')){
            
          if (category === 'satellital') {
            variableData = variableData.filter((item) => {
                const bandItem = (item && item.band ? String(item.band) : '').trim().toLowerCase();
                const bandSel  = (this.bandSelected ? String(this.bandSelected) : '').trim().toLowerCase();
                return bandItem === bandSel;
            });
            this.satellitalMinPoint = this.getMinMeanSatellitalPoint(variableData);
            this.satellitalMaxPoint = this.getMaxMeanSatellitalPoint(variableData);

            this.chartOptions['yAxis'][1]['title']['text'] = this.bandSelected;
            this.chartOptions['yAxis'][1]['min'] = this.satellitalMinPoint;
            this.chartOptions['yAxis'][1]['max'] = this.satellitalMaxPoint;
           }
            
         }
         
        points = variableData.map((item: RanchVariableData) => {
            let timestampAsDate = timestampToTime(item.date)
            let point = {
                x: timestampAsDate,
                yMin: item.value.min || null,
                yMax: item.value.max || null,
                yMean: item.value.mean,
            }
            return point
        })


        //las series de satelital van en el eje Y 1
        let serieYAxis = 0;
        if(category === 'satellital'){
            serieYAxis = 1;
        }

        //armo las series para el grafico
        let serieName = this.categoriesLabel[category];
        if(category === 'humidity'){
            //si la categoria es humedad, appendeo la aclaracion de humedad
            serieName = this.categoriesInfo[category]
        }
        const notNull = (xy) => xy[1] !== null && xy[1] !== undefined;

        let meanPoints = points.map(function(point) { return [point.x, point.yMean] }).sort() || [];
        let minPoints = points.map(function(point) { return [point.x, point.yMin] }).sort() || [];
        let maxPoints = points.map(function(point) { return [point.x, point.yMax] }).sort() || [];
        
        const hasMin = minPoints.some(notNull);
        const hasMax = maxPoints.some(notNull);

        let medianSerie = {
            name: `${serieName} (Mediana)`,
            color: this.categoriesColors[category].mean,
            data: meanPoints,
            type: seriesType,
            yAxis: serieYAxis,
            category: category
        };

        let newSeries:any[] = []

        if (category === 'satellital') {
            newSeries = [medianSerie];
        } else {
            if (hasMin){
                newSeries.push({
                    name: `${serieName} (Mín)`,
                    color: this.categoriesColors[category].min,
                    data: minPoints,
                    type: seriesType,
                    yAxis: serieYAxis,
                    category
                });
            }
            if (hasMax){
                newSeries.push({
                    name: `${serieName} (Max)`,
                    color: this.categoriesColors[category].max,
                    data: maxPoints,
                    type: seriesType,
                    yAxis: serieYAxis,
                    category
                });
            }
            newSeries.push(medianSerie);
        }


        if (this.variableIsActive('satellital')) {
            // Imagen seleccionada
            let tsSel: any = null;
            if (this.selectedImage && this.selectedImage['date']) {
                const t = moment(this.selectedImage['date']).toDate().valueOf();
                tsSel = isNaN(t) ? null : t;
            }

            this.applyPlotLines();
            this.updateChartReferences();
        }


        //agrego las series al grafico
        this.chartOptions['series'] = [
            ...this.chartOptions['series'],
            ...newSeries
        ]
    }


    @Watch('selectedImage', { deep: true })
    onSelectedImageChanged() {
    if (!this.variableIsActive('satellital')) return;
        this.applyPlotLines();
        this.updateChartReferences();
    }

    updateSatellitalLayersInfo(newLayersInfo){
        this.satellitalLayersInfo = newLayersInfo;
    }

    @Watch('satellitalLayersInfo', { immediate: true, deep: true })
    onSatellitalInfoChanged() {
        const info: any = this.satellitalLayersInfo;
        const dateStr = info && info.zonified && info.zonified.date;

        const t = (typeof dateStr === 'string') ? moment(dateStr).toDate().valueOf() : NaN;
        this.zonificationTs = isNaN(t) ? null : t;

        if (this.variableIsActive('satellital')) {
            this.applyPlotLines();
            this.updateChartReferences();
        }
    }

    updateIsLoadingLayers(value: boolean){
        this.isLoadingLayers = value;
    }

    getChartData(){
        this.updateIsLoadingLayers(true);
        let self = this;
        this.$nextTick(async () => {
            await self.getVariables();
            self.isLoaded = true;
        })
    }

    @Watch('activesVariables', { immediate: true })
    onActivesVariablesChange() {
        this.updateChartReferences();
        this.applyPlotLines();
    }

 


    mounted(){

    }

    preselectSatellitalVariable(){
        this.bandSelected = 'NDVI';
        this.toggleVariable('satellital');
    }


    getChartTypeByCategory(category:string){
        let types = {
            humidity: 'line',
            temperature: 'line',
            rain: 'column',
            satellital: 'line'
        }
        return types[category];
    }

    @Emit()
    clickChartPoint(pointIndex: number){}
}
